"use client";

import { useEffect, useState } from "react";
import { Trophy, Award, Target, Lightbulb } from "lucide-react";
import profile from "../../../assets/Images/profile.jpg";

export default function Mentors() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <section id="mentors" className="py-20 px-4 sm:px-6 lg:px-8 bg-white">
      <div className="max-w-6xl mx-auto">
        {/* Section Header */}
        <div
          className={`text-center mb-16 ${
            isVisible ? "animate-fade-in-up" : "opacity-0"
          }`}
        >
          <h2 className="text-4xl md:text-5xl font-bold mb-4 text-pretty">
            Meet Your{" "}
            <span className="text-[var(--primary-color)]">IIT Kanpur</span>{" "}
            Mentor
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Expert educator with proven excellence and deep domain knowledge in
            chemistry
          </p>
        </div>

        <div
          className={`max-w-3xl mx-auto ${
            isVisible ? "animate-fade-in-up" : "opacity-0"
          }`}
        >
          <div className="bg-white rounded-2xl border-2 border-[var(--primary-color)] overflow-hidden hover:shadow-2xl transition-all duration-300">
            <div className="grid md:grid-cols-2 gap-0 items-stretch">
              {/* Left: Image with Badge */}
              <div className="bg-white p-8 flex flex-col items-center justify-center relative">
                {/* <div className="text-9xl mb-4 animate-bounce">👨‍🔬</div> */}
                <img src={profile} alt="" className="" />
                {/* 
                <div className="absolute top-4 right-4 bg-gradient-to-r from-yellow-400 to-yellow-500 text-blue-950 px-4 py-2 rounded-full text-sm font-bold shadow-lg">
                  AIR 269
                </div> */}
              </div>

              {/* Right: Text Information */}
              <div className="p-8 flex flex-col justify-center">
                <h3 className="text-3xl font-bold text-blue-950 mb-1">
                  Mr. Sourabh Patidar
                </h3>
                <p className="text-lg text-yellow-500 font-semibold mb-4">
                  Chemistry Expert
                </p>

                <p className="text-gray-700 mb-6 leading-relaxed">
                  IIT Kanpur Student and Founder of Machine Academy. With over
                  5+ years of expertise in chemistry, Mr. Sourabh Patidar has
                  trained 20+ aspirants for competitive exams.
                </p>

                <div className="space-y-3">
                  {/* <p className="flex items-start gap-3 text-gray-700">
                    <span className="text-yellow-500 font-bold text-lg mt-1 flex-shrink-0">
                      ✓
                    </span>
                    <span>Secured AIR 269 in IIT JAM Chemistry</span>
                  </p> */}
                  <p className="flex items-start gap-3 text-gray-700">
                    <span className="text-yellow-500 font-bold text-lg mt-1 flex-shrink-0">
                      ✓
                    </span>
                    <span>5+ years of expertise</span>
                  </p>
                  <p className="flex items-start gap-3 text-gray-700">
                    <span className="text-yellow-500 font-bold text-lg mt-1 flex-shrink-0">
                      ✓
                    </span>
                    <span>Trained 20+ aspirants</span>
                  </p>
                </div>

                <button className="w-full mt-6 bg-gradient-to-r from-blue-600 to-blue-700 text-white px-6 py-3 rounded-lg font-semibold hover:from-blue-700 hover:to-blue-800 transition-all duration-300 hover:shadow-lg">
                  Schedule a Session
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
